// extracted by mini-css-extract-plugin
export default {"buttonBottom":"EditKpi_buttonBottom__ZO6n-","buttonCancel":"EditKpi_buttonCancel__UkD4X","buttonSaveChanges":"EditKpi_buttonSaveChanges__WnAi+","editForm":"EditKpi_editForm__euqsU"};